import {TenantProfileApi} from "../../services/api/base/TenantProfileApi";
import {BehaviorSubject} from "rxjs";

export class TenantProfileStore {

    private static instance: TenantProfileStore;

    public static getInstance(): TenantProfileStore {
        if (!TenantProfileStore.instance) {
            TenantProfileStore.instance = new TenantProfileStore();
        }
        return TenantProfileStore.instance;
    }

    private tenantProfileSubject = new BehaviorSubject<any>(null);
    public tenantProfile$ = this.tenantProfileSubject.asObservable();

    public setTenantProfile(booking: any) {
        this.tenantProfileSubject.next(booking);
    }

    public getTenantProfile() {
        return this.tenantProfileSubject.value;
    }


    public async fetch(tenantProfileApi: TenantProfileApi, tenantProfileId:string, parentTenantId: string) {
                
        const result = await tenantProfileApi.tryGet(
            null,
            parentTenantId,
            {
                tenantProfileId: tenantProfileId
            },
            true,
            false,
            true
        );

        this.setTenantProfile(result.data);
        
    }


}